import React, { useState, useEffect } from "react";

import RecentHistory from "./CommonJobBoardTabs/RecentHistory";
import SavedHistory from "./CommonJobBoardTabs/SavedHistory";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  NewTab,
  showToast,
  useFormHandler,
} from "../../../components";
import { CareerBuilderRadius } from "../../../assets/data/enumData";
import { getCareerBuilderApplicantsDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import SearchResults from "./SearchResults";
import { setcareerBuilderAccessidStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import {
  getCountries,
  getLocations,
} from "../../../redux/slices/internalDbES/internalDbESApi";
import { normalizeQuotes } from "../../../utils/common";
const CareerBuilder = () => {
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [validationRules, setValidationRules] = useState({});
  const { user } = useSelector((state) => state.auth);
  const [searchApplicant, setSearchApplicant] = useState(false);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.internalDbES);
  const [requestBody, setRequestBody] = useState(null);
  const [loadCareerBuilder, setLoadCareerBuilder] = useState(false);
  const [loader, setLoader] = useState(false);
  const [saveAccessId, setSaveAccessId] = useState(0);
  const [selectedTitle, setSelectedTitle] = useState("");
  const { accessData } = useSelector((state) => state.internalDbES);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [locationTypingValue, setLocationTypingValue] = useState("");
  const [locations, setLocations] = useState([]);
  const [isPrefilled, setIsPrefilled] = useState(true);
  // const [accountsModal, setAccountsModal] = useState(true);
  const [isSelection, setIsSelection] = useState(false);
  const [filterSearchPayload, setFilterSearchPayload] = useState([])

  const handleSelect = ({ title, filterTerms = {} }) => {
    //console.log("Selected item:", filterTerms);

    const mapped = {
      jobTitleOrKeyword: filterTerms?.Keywords ?? "",
      city: filterTerms?.City ?? "",
      country:
        filterTerms?.Country === "US"
          ? "United States"
          : filterTerms?.Country === "CA"
            ? "Canada"
            : "",

      state: filterTerms?.State ?? "",
      zipCode: filterTerms?.ZipCode ?? "", //`${filterTerms?.City},${filterTerms?.State},${filterTerms?.ZipCode}` ?? "",
      searchByName: filterTerms?.SearchPattern ?? "",
      milesToLocation: filterTerms?.SearchRadiusInMiles ?? "",
      searchByEmployer: filterTerms?.Company ?? "",
      searchByJobTitle: filterTerms?.JobTitle ?? "",
      //excludeSkills:filterTerms?.JobTitle ?? ""
      // add others only if required
    };
    setFilterSearchPayload(filterTerms)
    setSelectedCountry(
      `${filterTerms?.City},${filterTerms?.State},${filterTerms?.ZipCode}`,
    );
    setFormData({
      ...initialFormData,
      ...mapped,
    });
    setIsPrefilled(true);
    setLocationTypingValue(
      `${filterTerms.City},${filterTerms.State},${filterTerms.ZipCode}`,
    );
    setSelectedTitle(title);
  };

  // useEffect(() => {
  //   setAccountsModal(accountsModal);
  // }, [accountsModal]);

  useEffect(() => {
    const fetchIntegrationAccess = async () => {
      setLoader(true);
      try {
        const params = {
          coll: "IntegrationAccess",
          fil: {
            userId: {
              type: "FIND_INTIGRATION_ACCESS",
              value: user?.data?.uiid,
              category: 3,
              categoryType: 2,
              status: 1,
            },
          },
          useAggregate: true,
        };

        //const response = await getAllIntegrationAccess(params);
        // console.log("Career Builder integration access success data:", response?.data);
        const dispatchData = () => {
          dispatch(setcareerBuilderAccessidStart(params));
          const { accessData } = useSelector((state) => state.internalDbES);
          return {
            status:
              accessData?.careerBuilder?.[0]?.integrationData?.status ?? null,
            accessId: accessData?.careerBuilder?.[0]?.uiid ?? null,
          };
        };

        const accessId =
          accessData?.careerBuilder?.[0]?.uiid ?? dispatchData()?.accessId;
        const status =
          accessData?.careerBuilder?.[0]?.integrationData?.status ??
          dispatchData()?.status;

        setSaveAccessId(accessId);
        if (typeof status !== "undefined") {
          if (status === 1) {
            // showToast("Career Builder integration is active", "success");
            setLoadCareerBuilder(true);
          } else {
            showToast(
              "Career Builder integration access not found. Please contact the administrator",
              "error",
            );
          }
        } else {
          showToast(
            "Career Builder integration status not found. Please contact the administrator",
            "error",
          );
        }
      } catch (err) {
        console.error("Error fetching integration access:", err);
      } finally {
        setLoader(false);
      }
    };

    fetchIntegrationAccess();
  }, []);
  //console.log("accessId", accessData);
  const initialFormData = {
    jobTitleOrKeyword: "",
    city: "",
    state: "",
    zipCode: "",
    searchByName: "",
    excludeSkills: "",
    searchByJobTitle: "",
    searchByEmployer: "",
    milesToLocation: 50,
    country: "United States",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  const buildBooleanSearch = (include = "", exclude = "") => {
    /* ---------- helpers ---------- */

    // Normalize smart quotes + spacing
    const normalize = (str = "") =>
      str
        .replace(/[“”]/g, '"')
        .replace(/[‘’]/g, "'")
        .trim()
        .replace(/\s+/g, " ")
        .replace(/\bAND\b/gi, "AND")
        .replace(/\bOR\b/gi, "OR")
        .replace(/\bNOT\b/gi, "NOT");

    const isOperator = (t) => ["AND", "OR", "NOT"].includes(t);
    const isParen = (t) => t === "(" || t === ")";
    const isQuoted = (t) => t.startsWith('"') && t.endsWith('"');
    const isTerm = (t) => !isOperator(t) && !isParen(t);

    /* ---------- tokenizer (SAFE) ---------- */
    const tokenize = (str) =>
      str.match(/"[^"]*"|\(|\)|\bAND\b|\bOR\b|\bNOT\b|[^\s()]+/gi) || [];

    /* ---------- insert missing ANDs (never inside quotes) ---------- */
    const insertMissingAND = (tokens) => {
      const out = [];

      for (let i = 0; i < tokens.length; i++) {
        const curr = tokens[i];
        const next = tokens[i + 1];

        out.push(curr);
        if (!next) continue;

        // 🚫 never touch quoted phrases
        if (isQuoted(curr) || isQuoted(next)) continue;

        // term term → AND
        if (isTerm(curr) && isTerm(next)) {
          out.push("AND");
          continue;
        }

        // ) term → AND
        if (curr === ")" && isTerm(next)) {
          out.push("AND");
          continue;
        }

        // term ( → AND
        if (isTerm(curr) && next === "(") {
          out.push("AND");
          continue;
        }

        // ) ( → AND
        if (curr === ")" && next === "(") {
          out.push("AND");
        }
      }

      return out;
    };

    /* ---------- process include ---------- */
    const inc = normalize(include);
    let incTokens = tokenize(inc);
    incTokens = insertMissingAND(incTokens);

    /* ---------- process exclude ---------- */
    const exc = normalize(exclude);
    let excTokens = tokenize(exc);

    if (excTokens.length) {
      excTokens = excTokens.map((t) =>
        isOperator(t) || isParen(t) ? t : `NOT ${t}`,
      );
    }

    /* ---------- build final ---------- */
    const parts = [];
    if (incTokens.length) parts.push(incTokens.join(" "));
    if (excTokens.length) parts.push(excTokens.join(" AND "));

    return parts.join(" AND ");
  };

  const onSuccess = () => {
    setSearchApplicant((prev) => !prev);
  };
  const handleHistorySearch = ({ title, filterTerms }) => {
    handleSearch(title, filterTerms);
    setSelectedTitle("");

  };

  const parseLocation = (value = "") => {
    const parts = value
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    let city = "";
    let state = "";
    let zipCode = "";

    if (parts.length === 3) {
      // city,state,zip
      [city, state, zipCode] = parts;
    } else if (parts.length === 1) {
      // single value → ONLY state
      state = parts[0];
    }

    return { city, state, zipCode };
  };

  const handleSearch = async (title, filteredTerms) => {
    let keyword; //= formData.jobTitleOrKeyword || selectedTitle || title;
    if (title) {
      keyword = title;
    } else {
      keyword = formData.jobTitleOrKeyword || selectedTitle || title;
    }
    if (!keyword) {
      showToast("Job Title or keyword is required!", "error");
      return;
    }

    const openParen = (keyword.match(/\(/g) || []).length;
    const closeParen = (keyword.match(/\)/g) || []).length;

    if (openParen !== closeParen) {
      showToast("Invalid keyword syntax: missing ')'.", "error", 2000);
      return;
    }

    // check unbalanced double quotes
    const quotes = (keyword.match(/"/g) || []).length;

    if (quotes % 2 !== 0) {
      showToast('Invalid keyword syntax: missing closing "', "error", 2000);
      return;
    }

    const booleanQuery = buildBooleanSearch(keyword, formData.excludeSkills);
    // const [city, state, zipCode] = locationTypingValue.split(",");
    const { city, state, zipCode } = parseLocation(locationTypingValue);
    //console.log({ city, state, zipCode });

    const newRequestBody = {
      accessId: saveAccessId || accessData?.careerBuilder?.[0]?.uiid,
      userId: user?.data?.uiid,
      payload: {
        query: {
          // SearchPattern: "Boo",
          Keywords: booleanQuery,
          City: city || formData.city?.value || formData.city || "",
          State: state || formData.state?.value || formData.state || "",
          // ZipCode: zipCode || formData.zipCode || "",
          ZipCode:
            zipCode ||
            (!isNaN(Number(formData.zipCode)) && formData.zipCode !== ""
              ? Number(formData.zipCode)
              : ""),
          Country: selectedCountry?.iso2 || "US",
          JobTitle: formData?.searchByJobTitle || "",
          Company: formData.searchByEmployer || "",
          SearchRadiusInMiles:
            Number(formData.milesToLocation?.value) ||
            Number(formData.milesToLocation) ||
            50,
          // "SearchPattern": "Boo", //Boolean Search
          // "Keywords": "Python and aws and sql",
          // "City": "Atlanta",
          // "State": "GA",
          // "ZipCode": 30092,
          // "Country": "US",
          // "JobTitle": "Fullstack Developer or Software Engineer", //maximum 3 (must seperated by - OR)
          // "Company": "Amazon or Meta", //maximum 3 (must seperated by - OR)
          // "SearchRadiusInMiles": 50
          ...filteredTerms,
          ...filterSearchPayload
        },
        page: 1,
        lim: 25,
        addedBy: user?.data?.uiid,
        source: 2,
      },
    };

    try {
      setRequestBody(newRequestBody);
      dispatch(
        getCareerBuilderApplicantsDataStart({
          ...newRequestBody,
          onSuccess: () => {
            setSearchApplicant((prev) => !prev);
            setFormData(initialFormData);
            setSelectedTitle("");
            setLocationTypingValue("");
            setFilterSearchPayload([])
          },
        }),
      );
    } catch (error) {
      console.error("CareerBuilder search error:", error);
    } finally {
    }
  };

  const careerBuilderMenus = [
    {
      title: "Recent History",
      page: (
        <RecentHistory
          board="careerBuilder"
          onSelect={handleSelect}
          onClick={handleHistorySearch}
        />
      ),
      type: "main",
    },
    {
      title: "Saved History",
      page: (
        <SavedHistory
          board="careerBuilder"
          onSelect={handleSelect}
          onClick={handleHistorySearch}
        />
      ),
      type: "main",
    },
  ];

  useEffect(() => {
    // if (!locationTypingValue) {
    //   setLocations([]);
    //   return;
    // }
    if (!locationTypingValue || isSelection) {
      setIsSelection(false);
      return;
    }
    const [city, state, zip] = locationTypingValue.split(",");
    if (city && state) {
      setLocations([]);
      return;
    }

    const delay = setTimeout(async () => {
      setLocations([]);
      const response = await getLocations({
        locationValue: locationTypingValue,
        country: selectedCountry?._id,
        limit: 500,
      });
      if (response?.success) {
        // const locationData = response?.data?.data
        //   .map((item) => {
        //     const name = item.name ?? "";
        //     const state = item.stateName ?? "";
        //     const zip = item.zipCode ?? "";

        //     return `${name},${state},${zip}`.trim();
        //   });
        const uniqueStates = [
          ...new Set(
            (response?.data?.data || []).map((item) => item.stateName),
          ),
        ];
        const locationData = response?.data?.data.flatMap((item) => {
          const name = item.name ?? "";
          const state = item.stateName ?? "";

          // If zipCode is array, return one entry per zip
          if (Array.isArray(item.zipCode)) {
            return item.zipCode.map((zc) => `${name},${state},${zc}`);
          }

          // If zipCode is a single string
          return [`${name},${state},${item.zipCode ?? ""}`];
        });
        const search = locationTypingValue.toLowerCase();
        const statesStartsWith = uniqueStates.filter((item) =>
          item.toLowerCase().startsWith(search),
        );
        const statesContains = uniqueStates.filter(
          (item) =>
            item.toLowerCase().includes(search) &&
            !item.toLowerCase().startsWith(search),
        );
        const locationsStartsWith = locationData.filter((item) =>
          item.toLowerCase().startsWith(search),
        );
        const locationsContains = locationData.filter(
          (item) =>
            item.toLowerCase().includes(search) &&
            !item.toLowerCase().startsWith(search),
        );
        statesStartsWith.sort((a, b) => a.localeCompare(b));
        statesContains.sort((a, b) => a.localeCompare(b));
        locationsStartsWith.sort((a, b) => a.localeCompare(b));
        locationsContains.sort((a, b) => a.localeCompare(b));
        setLocations([
          ...statesStartsWith,
          ...locationsStartsWith,
          ...statesContains,
          ...locationsContains,
        ]);
        // setLocations([...uniqueStates, ...locationData])
      }
    }, 0);

    return () => clearTimeout(delay);
  }, [locationTypingValue, formData?.country]);

  useEffect(() => {
    if (!formData?.country) return;

    const delay = setTimeout(async () => {
      const response = await getCountries({ name: formData?.country });
      const countries = response.data.data;
      const desiredCountry = countries[0];

      setSelectedCountry(desiredCountry);
      setLocationTypingValue("");
    }, 0);

    return () => clearTimeout(delay);
  }, [formData?.country]);

  if (loader) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LogoLoader />
      </div>
    );
  }

  return !searchApplicant ? (
    <div className=" flex flex-1 flex-col p-2 overflow-auto">
      <p className="p-4 font-[600]">Career Builder</p>
      <div className="p-3 flex flex-1 md:flex-col lg:flex-row shadow">
        <div className="flex-1 m-4 inner-section rounded-md">
          <div className="grid grid-cols-1 m-3 ">
            <FormFieldSet
              noTitle
              placeholder="Job Title or Keyword"
              value={formData.jobTitleOrKeyword || selectedTitle}
              onChange={(value) => {
                handleChange("jobTitleOrKeyword", normalizeQuotes(value));
                setSelectedTitle("");
              }}
              error={errors.jobTitleOrKeyword}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-2 mx-3 my-5 gap-5">
            {/* <FormFieldSet
              // type="select"
              type="states"
              placeholder="City"
              noTitle
              value={formData.city}
              onChange={(value) => handleChange("city", value)}
              error={errors.city}
              shadow={true}
            /> */}
            {/* <FormFieldSet
              // type="select"
              type="states"
              placeholder="State"
              noTitle
              value={formData.state}
              onChange={(value) => {
                handleChange("state", value);
                // console.log("Valu", value);
              }}
              error={errors.state}
              shadow={true}
              parentValue={{ country: "United States" }}
            />
            <FormFieldSet
              // type="select"
              type="cities"
              placeholder="City"
              noTitle
              value={formData.city}
              onChange={(value) => handleChange("city", value)}
              error={errors.city}
              parentValue={{
                // country: formData.country?.value,
                country: "United States",
                state: formData.state?.value,
              }}
              disabled={!formData.state}
            /> */}
            <FormFieldSet
              type="countriesUsAndCanada"
              noTitle
              placeholder="Country"
              // type="select"
              // options={[
              //   { label: "United States", value: "US" },
              //   { label: "Canada", value: "CA" },
              // ]}
              value={formData?.country}
              onChange={(value) => {
                handleChange("country", value.value);
              }}
            />

            <FormFieldSet
              noTitle
              placeholder="Zipcode"
              value={locationTypingValue}
              onChange={(value) => {
                setLocationTypingValue(value);
                setIsSelection(locations.includes(value));
                // setIsPrefilled(true); // stop using initial mapped values
                // handleChange("zipCode", value);
                // setLocations([]);

                if (locations.includes(value)) {
                  setLocations([]);
                }
                if (!value || value.trim() === "") {
                  handleChange("city", "");
                  handleChange("state", "");
                  handleChange("zipCode", "");
                }
              }}
              error={errors.zipCode}
              shadow={true}
              suggestionsList={locations}
            />
          </div>

          <div className="flex justify-end">
            {advancedSearch ? (
              <Button
                variant="text"
                title="Hide Advanced Search"
                color="info"
                className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            ) : (
              <Button
                variant="text"
                title="Advanced Search"
                color="info"
                className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            )}
          </div>
          {advancedSearch ? (
            <div className="grid md:grid-cols-2 2xl:grid-cols-3  mx-3 my-6 gap-8">
              {/* <FormFieldSet
                placeholder="search by Name"
                noTitle
                value={formData.searchByName}
                onChange={(value) => handleChange("searchByName", value)}
                error={errors.searchByName}
                shadow={true}
              /> */}
              <FormFieldSet
                placeholder="Exclude skills"
                noTitle
                value={formData.excludeSkills}
                onChange={(value) => handleChange("excludeSkills", value)}
                error={errors.excludeSkills}
                shadow={true}
              />
              <FormFieldSet
                placeholder="Search by Job Title"
                noTitle
                value={formData.searchByJobTitle}
                onChange={(value) => handleChange("searchByJobTitle", value)}
                error={errors.searchByJobTitle}
                shadow={true}
              />
              <FormFieldSet
                placeholder="Search by Employer"
                noTitle
                value={formData.searchByEmployer}
                onChange={(value) => handleChange("searchByEmployer", value)}
                error={errors.searchByEmployer}
                shadow={true}
              />
              <FormFieldSet
                type="select"
                placeholder="Miles to Location"
                noTitle
                options={CareerBuilderRadius}
                value={formData.milesToLocation}
                onChange={(value) => handleChange("milesToLocation", value)}
                error={errors.milesToLocation}
                shadow={true}
              />
            </div>
          ) : (
            ""
          )}

          <div className="grid grid-cols-1 mx-5 my-10 gap-8">
            <Button
              disabled={
                !loadCareerBuilder &&
                !saveAccessId &&
                !accessData?.careerBuilder?.[0]?.uiid
              }
              title="Search Applicant"
              className="rounded-full"
              onClick={() => handleSearch()}
            />
          </div>
        </div>
        <div className="flex flex-1 flex-col mx-2">
          <p className="font-[600] mx-2">Strings History</p>
          <div className="flex flex-1 shadow m-2 p-3 ">
            <NewTab
              tabs={careerBuilderMenus}
              color="gray"
              variant="text"
              activeVariant="text"
            />
          </div>
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      {/* <AccountsModal
        isOpen={accountsModal}
        onClose={() => setAccountsModal(false)}
      /> */}
    </div>
  ) : (
    <div className="flex flex-1 flex-col overflow-hidden mt-2">
      <SearchResults
        source={2}
        query={requestBody}
        loading={loading}
        setSearchApplicant={setSearchApplicant}
      />
    </div>
  );
};

export default CareerBuilder;
